import { api } from '../api';

const getVehicleDepartments = async ({ customerId, vouId }) => {
  const response = await api({
    url: `VehicleDepartments/getList`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      CustomerId: customerId,
      VouId: vouId,
    },
  });
  return response.data;
};

const getVehicleFuelTypes = async ({ vouId = 4 }) => {
  const response = await api({
    url: `Vehicles/GetVehicleFuelTypes`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      VouId: vouId,
    },
  });
  return response.data;
};

const getVehicleCostCenter = async ({ customerId, vouId, costCenterId }) => {
  const response = await api({
    url: `Vehicles/GetVehicleCostCenter`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      customerId: customerId,
      VouId: vouId,
    },
  });
  return response.data;
};

const getVehicleLimitTypes = async ({ vouId, customerId, limitTypeId }) => {
  const response = await api({
    url: `Vehicles/GetVehicleLimitTypes`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      CustomerId: customerId,
      VouId: vouId,
    },
  });
  return response.data;
};

const getVehicleLimitValueTypes = async ({ customerId }) => {
  const response = await api({
    url: `Vehicles/GetVehicleLimitValueTypes`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      CustomerId: customerId,
    },
  });
  return response.data;
};

const getVehicleTypes = async () => {
  const response = await api({
    url: `Vehicles/GetVehicleTypes`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
  });
  return response.data;
};

const getVehicleAttributes = async () => {
  const response = await api({
    url: `Vehicles/GetVehicleAttributes`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
  });
  return response.data;
};

const getVehicleLAddressGetList = async ({ customerId }) => {
  const response = await api({
    url: `Addresses/GetList`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      customerId: customerId,
    },
  });
  return response.data;
};

const postVehicles = async ({ vehicles }) => {
  const response = await api({
    url: `Vehicles`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: { vehicles },
  });
  return response.data;
};

const getVehicleForThanksPage = async ({ customerId, vouId, deviceTypeId }) => {
  const response = await api({
    url: `Vehicles/GetVehicleForThanksPage`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      CustomerId: customerId,
      VouId: vouId,
      DeviceTypeId: deviceTypeId,
    },
  });
  return response.data;
};

const addCarPlateDetailServices = {
  getVehicleLAddressGetList,
  getVehicleLimitValueTypes,
  getVehicleFuelTypes,
  getVehicleDepartments,
  getVehicleCostCenter,
  getVehicleLimitTypes,
  getVehicleAttributes,
  getVehicleTypes,
  postVehicles,
  getVehicleForThanksPage,
};

export default addCarPlateDetailServices;
